"use client";

import { TabBar } from "@/components/tab-bar";
import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const ID = "stock-list";

type Chain = { feed: number; name: string; description: string };

type StockListProps = {
  chains: Chain[];
  tabChains?: Chain[];
};

const StockList = (props: StockListProps) => {
  const router = useRouter();
  const { isReady, load } = useInfront();
  const widgetRef = useRef<any>(null);
  const [activeTab, setActiveTab] = useState<string>("");

  const tabs = props.tabChains?.map((c) => c.description);
  const selectedTab = activeTab || tabs?.[0];

  const activeChains = props.tabChains
    ? activeTab
      ? props.tabChains.filter((c) => c.description === activeTab)
      : props.tabChains.slice(0, 1)
    : props.chains;

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.QuoteListWidgetOptions();

      widgetOptions.onInstrumentSelected = (instrument: {
        feed: number;
        ticker: string;
      }) => {
        router.push(createInstrumentSlug(instrument.feed, instrument.ticker));
      };

      widgetOptions.widgetTitle = "Aktier";
      widgetOptions.defaultContent = DEFAULT_CONTENT;
      widgetOptions.useChains = true;
      widgetOptions.chains = activeChains;
      widgetOptions.enableChangeStatusColors = true;
      widgetOptions.instrumentTypes = ["STOCK"];

      if (!props.tabChains) {
        widgetOptions.chainButtonTitle = "Listor";
      }

      widgetOptions.columns = [
        { name: "TICKER", flag: true },
        "LAST",
        "PCT_CHANGE",
        "CHANGE",
        "S_MARKET_PRICE",
        "ACC_VOLUME",
        "TIME",
      ];

      widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router, activeTab, props.chains]);

  if (!tabs) {
    return <div className="card" id={ID} />;
  }

  return (
    <div className="card [&_.cell-mininav__btn]:hidden">
      <TabBar
        tabs={tabs.map((t) => ({ label: t, value: t }))}
        active={selectedTab ?? tabs[0]}
        onChange={setActiveTab}
      />
      <div id={ID} />
    </div>
  );
};

export default StockList;
